module.exports = __webpack_public_path__ + "static/media/yt_play.ea93980b.svg";